import {
  Box,
  Center,
  useColorModeValue,
  Heading,
  Text,
  Stack,
} from "@chakra-ui/react";
import NextLink from "next/link";
import Image from "next/image";

export default function BlogCard({ data }) {
  return (
    <Center>
      <Box
        role={"group"}
        p={6}
        maxW={"360px"}
        w={"full"}
        bg={useColorModeValue("white", "gray.800")}
        boxShadow={"rgba(0, 0, 0, 0.15) 0px 5px 15px 0px"}
        rounded={"lg"}
        pos={"relative"}
        zIndex={1}
        height={"full"}
        cursor={"pointer"}
        _hover={{
          transform: "scale(1.04)",
        }}
      >
        <NextLink href={`/blog/${data.slug}`}>
          <Box
            rounded={"lg"}
            pos={"relative"}
            height={"200px"}
            cursor={"pointer"}
            _groupHover={{
              _after: {
                filter: "blur(20px)",
              },
            }}
          >
            <Image
              alt={data.Image?.data?.attributes.name}
              src={
                process.env.NEXT_PUBLIC_SERVER_URL +
                data.Image?.data?.attributes.url
              }
              height={200}
              width={312}
              style={{
                objectFit: "cover",
                height: "200px",
                borderRadius: "0.5rem",
                margin: "auto",
              }}
            />
          </Box>
        </NextLink>
        <Stack pt={5} align={"center"} className="blogcard_detail">
          <NextLink href={`/blog/${data.slug}`}>
            <Heading
              fontSize={"xl"}
              fontWeight={500}
              color={"blue.10"}
              pb={5}
              cursor={"pointer"}
              position="relative"
              textAlign={"left"}
              w={"100%"}
              _hover={{
                color: "blue.800",
              }}
              _after={{
                content: '""',
                position: "absolute",
                color: "blue.10",
                width: "50px",
                height: "2px",
                bg: "blue.10",
                bottom: "10px",
                left: "50%",
                transform: "translateX(-50%)",
                right: "0",
              }}
            >
              {data?.Title}
            </Heading>
          </NextLink>
          <Text
            overflow={"hidden"}
            textOverflow={"ellipsis"}
            noOfLines={4}
            color={"lightBlue.10"}
            fontSize={"md"}
          >
            {data?.Shot_Description}
          </Text>
        </Stack>
      </Box>
    </Center>
  );
}
